(() => {
  const menu = document.querySelector('.rv-mobile-menu');
  if (!menu || menu.dataset.menuEnhanced) return;
  const toggle = menu.querySelector('summary');
  const panel = menu.querySelector('nav');
  let closeTimer;

  function reflect(open) {
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    toggle.setAttribute('aria-expanded', String(open));
  }

  function finishClose() {
    if (menu.dataset.menuClosing !== 'true') return;
    clearTimeout(closeTimer);
    menu.open = false;
    delete menu.dataset.menuClosing;
    delete menu.dataset.menuVisible;
    reflect(false);
  }

  function open() {
    clearTimeout(closeTimer);
    delete menu.dataset.menuClosing;
    if (!menu.open) {
      menu.open = true;
      menu.dataset.menuVisible = 'false';
      // Commit the hidden starting state before the opacity transition.
      panel.getBoundingClientRect();
    }
    panel.inert = false;
    menu.dataset.menuVisible = 'true';
    reflect(true);
  }

  function close(returnFocus = false) {
    if (!menu.open) return;
    if (returnFocus) toggle.focus();
    if (menu.dataset.menuClosing === 'true') return;
    menu.dataset.menuClosing = 'true';
    menu.dataset.menuVisible = 'false';
    panel.inert = true;
    reflect(false);
    // transitionend normally closes the details; the timer covers interruption.
    closeTimer = setTimeout(finishClose, 240);
  }

  panel.id ||= 'RejuviaMobileNavigation';
  toggle.setAttribute('aria-controls', panel.id);
  menu.dataset.menuEnhanced = 'true';
  panel.inert = !menu.open;
  if (menu.open) menu.dataset.menuVisible = 'true';
  reflect(menu.open);

  toggle.addEventListener('click', event => {
    event.preventDefault();
    if (menu.dataset.menuVisible === 'true') close();
    else open();
  });
  panel.addEventListener('transitionend', event => {
    if (event.target === panel && event.propertyName === 'opacity') finishClose();
  });
  menu.addEventListener('toggle', () => {
    if (menu.open) {
      if (menu.dataset.menuVisible !== 'true' && menu.dataset.menuClosing !== 'true') open();
    } else {
      clearTimeout(closeTimer);
      delete menu.dataset.menuClosing;
      delete menu.dataset.menuVisible;
      panel.inert = true;
      reflect(false);
    }
  });
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      close(true);
    }
  }, true);
  menu.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !menu.open || menu.dataset.menuClosing === 'true') return;
    const last = menu.querySelector('.rv-mobile-shop');
    if (event.shiftKey && document.activeElement === toggle) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      toggle.focus();
    }
  });
  addEventListener('resize', () => {
    if (getComputedStyle(menu).display === 'none') {
      clearTimeout(closeTimer);
      menu.open = false;
      delete menu.dataset.menuClosing;
      delete menu.dataset.menuVisible;
      reflect(false);
    }
  });
})();
